<template>
  <div class="wrapper">
    <!-- *** 新增：將 PNO 輸入和操作按鈕直接放在 template 中 *** -->
    <el-form :inline="true" class="draft-actions-form">
        <el-form-item :label="$t('emg.listCommon.pno')">
            <el-input 
                type="textarea"
                v-model="pnoInput"
                :rows="3"
                :placeholder="$t('emg.listCommon.pnoPlaceholder')"
                class="pno-textarea">
            </el-input>
        </el-form-item>
        
        <el-form-item :label="$t('emg.listCommon.templateType')">
            <el-select v-model="templateTypeInput" :placeholder="$t('emg.listCommon.templateTypePlaceholder')">
                <el-option label="GM" value="GM"></el-option>
                <el-option label="CX" value="CX"></el-option>
            </el-select>
        </el-form-item>
        
        <el-form-item class="action-buttons">
            <el-button @click="handleCreateSingleDraft" :loading="pnoValidationLoading">{{ $t("emg.bt.createSingleDraft") }}</el-button>
            <el-button @click="handleBatchAddClick" :loading="batchAddLoading">{{ $t("emg.bt.batchAdd") }}</el-button>
            <el-button @click="handleEditTemplates">{{ $t("emg.bt.editEmailTemplate") }}</el-button>
        </el-form-item>
    </el-form>

    <FORM ref="childForm" @formclick="formclick" :formData="searchFormData"></FORM>

    <!-- 用於在表單下方顯示 PNO 驗證或擴充功能通訊的錯誤訊息 -->
    <div v-if="pnoValidationErrors.length > 0" class="validation-error">
        <ul class="error-list">
            <li v-for="(error, index) in pnoValidationErrors" :key="index">{{ error }}</li>
        </ul>
    </div>

    <table-page ref="childTable" :pageData="pageData"></table-page>

    <!-- *** 新增：批量新增的分類和確認對話框 *** -->
    <el-dialog
      :title="$t('emg.listMsg.batchAddConfirmTitle')"
      :visible.sync="batchAddModalVisible"
      width="600px"
      :before-close="() => batchAddModalVisible = false">
      
      <div v-if="batchAddLoading" style="text-align: center;">
        <i class="el-icon-loading"></i> {{ $t('emg.listMsg.classifying') }}
      </div>
      
      <div v-else>
        <el-form label-position="top">
          <el-form-item :label="$t('emg.listMsg.gmPnos')">
            <el-input type="textarea" :rows="10" v-model="classifiedPnos.gm" readonly></el-input>
          </el-form-item>
          <el-form-item :label="$t('emg.listMsg.cxPnos')">
            <el-input type="textarea" :rows="10" v-model="classifiedPnos.cx" readonly></el-input>
          </el-form-item>
          <el-form-item :label="$t('emg.listMsg.invalidPnos')">
            <el-input type="textarea" :rows="5" v-model="classifiedPnos.unknown" readonly></el-input>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="batchAddModalVisible = false">{{ $t("emg.bt.cancel") }}</el-button>
        <el-button 
          type="primary" 
          @click="handleConfirmBatchAdd"
          :disabled="batchAddLoading || (!classifiedPnos.gm && !classifiedPnos.cx)">
          {{ $t("emg.bt.confirmAdd") }}
        </el-button>
      </span>
    </el-dialog>

    <!-- 編輯電郵模版的對話框 -->
    <template-modal 
      :visible="templateVisible"
      @close="templateVisible = false"
      @save-success="showGlobalSuccess"
      @save-error="showGlobalError"
    />

  </div>
</template>

<script>
  import download from '@/utils/download'
  import { getToken, setToken, removeToken } from '@/utils/auth'
  import { localSave, localRemove, localRead, getQueryString } from '@/utils/tools'

  import tablePage from '@/components/page/table.vue'               //table封装组件
  import FORM from '@/components/page/form.vue'

  import URL from '@/views/emg/util/url'
  import TemplateModal from '@/views/emg/dden/template.vue';       // **新增**：匯入新的模版編輯組件

  export default {
    name: 'list',

    components: {
      tablePage,
      FORM,
      'template-modal': TemplateModal
    },

    data () {
      return {
        pnoValidationErrors: [],
        pnoValidationLoading: false,

        // **新增**：批量新增相關的 state
        batchAddModalVisible: false,
        batchAddLoading: false,
        classifiedPnos: {
          gm: '',
          cx: '',
          unknown: ''
        },

        // **新增**：控制模版編輯彈窗的 state
        templateVisible: false,

        // **新增**：為新的輸入欄位建立 data properties
        pnoInput: '',
        templateTypeInput: 'GM',

        queryData:{},

        /*from查询表单*/
        searchFormData:{
          hasLable: true,
          cols: [
              { title: this.$t("emg.listCommon.accountNo"), field: 'accountNo' },
              { title: this.$t("emg.listCommon.proposalNo"), field: 'pno' },
              { title: this.$t("emg.listCommon.paidAmount"), field: 'gatewayAmount' },
              { title: this.$t("emg.listCommon.gatewayName"), field: 'foDisplayNameCn' },
              {
                  title: this.$t("emg.common.businessType"),
                  field: 'businessType',
                  type: 2,
                  placeholder: this.$t("emg.common.businessTypePlaceholder"),
                  data: '',
                  optionList: [
                      { key: '', value: '' }, // 空白選項
                      { key: 'default', value: this.$t("emg.common.businessTypeGM") },
                      { key: 'cx', value: this.$t("emg.common.businessTypeCX") }
                  ]
              },
              { title: this.$t("emg.common.queryTime"), field: 'emailSentTime', type: 6, noTable: true },
              { click: this.$t("common.search") },
              { click: this.$t("common.reset") },
              { click: this.$t("emg.bt.export") }
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.dden.query,
          sequence: false,
          cols: [
              { title: this.$t("emg.common.sequence"), field: 'id' },
              { title: this.$t("emg.listCommon.accountNo"), field: 'accountNo' },
              { title: this.$t("emg.listCommon.name"), field: 'chineseName' },
              { title: this.$t("emg.listCommon.proposalNo"), field: 'pno' },
              { title: this.$t("emg.listCommon.currency"), field: 'gatewayCurrency' },
              { title: this.$t("emg.listCommon.paidAmount"), field: 'gatewayAmount' },
              { title: this.$t("emg.listCommon.gatewayName"), field: 'foDisplayNameCn' },
              { title: this.$t("emg.common.businessType"), field: 'businessType' },
              { title: this.$t("emg.listCommon.emailSentTime"), field: 'emailSentTime' },
              { title: this.$t("emg.listCommon.proposalStatus"), field: 'proposalStatus' },
              { title: this.$t("emg.listCommon.lastUpdateTime"), field: 'lastUpdateTime' },
              { title: this.$t("emg.listCommon.depositDiscrepancyProcessTime"), field: 'depositDiscrepancyProcessTime' },
          ]
        }
      }
    },

    methods: {
      /*查詢表單按鈕點擊事件*/
      formclick(clickName, data){

        this.pnoValidationErrors = [];  // 清空錯誤陣列

        if(data.emailSentTime!=undefined &&data.emailSentTime.indexOf(",")!=-1){
            let timeArr=data.emailSentTime.split(",");
            data.endTime=timeArr[1];
            data.startTime=timeArr[0];
            data.emailSentTime = null;
        }

        // --- 根據按鈕名稱分發任務 ---
        if (clickName === this.$t("common.search")) {
            this.queryData = data;
            this.$refs.childTable.defaultGetData(data);
        } else if (clickName === this.$t("emg.bt.export")) {
            download.exportExcel(URL.dden.export, data, this.$t('emg.listMsg.exportListTitle'));
        } else if (clickName === this.$t("common.reset")) {
            this.handleReset();
        }
      },

      // 一個輔助函數來新增錯誤訊息
      addError(message) {
        const timestamp = new Date().toLocaleTimeString('en-GB'); // 使用 24 小時制
        this.pnoValidationErrors.unshift(`[${timestamp}] ${message}`);
        console.error(message);
      },

      handleReset() {
        // 1. 重設搜尋表單的資料
        // Create a new object to ensure reactivity
        const newCols = this.searchFormData.cols.map(col => {
            if (col.field) {
                return { ...col, data: null };
            }
            return col;
        });
        this.searchFormData.cols = newCols;

        // 2. 清空父組件中的所有相關資料
        this.queryData = {};              
        this.pnoInput = '';               
        this.templateTypeInput = 'GM';    
        this.pnoValidationErrors = [];   

        // 3. 重新載入表格，傳遞一個空物件來獲取所有資料
        this.$refs.childTable.defaultGetData({});
        
        this.showGlobalSuccess(this.$t('emg.msg.resetSuccess'));
      },

      async handleCreateSingleDraft() {
          this.pnoValidationErrors = []; 
          const pnoToValidate = this.pnoInput || '';
          if (!pnoToValidate.trim()) {
              this.addError(this.$t('emg.listMsg.pnoRequiredForSingle'));
              return;
          }
          
          this.pnoValidationLoading = true;
          try {
              const validationResponse = await this.$axios.post(URL.dden.validatePno, { pno: pnoToValidate.trim() }, {
                headers: { 'Content-Type': 'application/json' }
              });
              if (!validationResponse.result || !validationResponse.result.isValid) {
                  throw new Error(this.$t('emg.listMsg.invalidPnoError'));
              }

              const templateResponse = await this.getFilledTemplates([pnoToValidate.trim()], this.templateTypeInput);
              if (templateResponse && templateResponse.length > 0) {
                  this.sendToExtension('openDraftWindowWithContent', templateResponse[0]);
              } else {
                  throw new Error(this.$t('emg.listMsg.getTemplateFailed'));
              }
          } catch (error) {
            this.addError(this.parseApiError(error));
          } finally {
              this.pnoValidationLoading = false;
          }
      },

      async handleBatchAddClick() {
          this.pnoValidationErrors = []; 
          const pnoInputVal = this.pnoInput || '';
          if (!pnoInputVal.trim()) {
              this.addError(this.$t('emg.listMsg.pnoRequiredForBatch'));
              return;
          }
          const pnos = pnoInputVal.split(/, |,/).map(p => p.trim()).filter(p => p);
          if (pnos.length > 50) {
              this.addError(this.$t('emg.listMsg.pnoBatchLimit'));
              return;
          }
          this.batchAddModalVisible = true;
          this.batchAddLoading = true;
          try {
              const response = await this.$axios.post(URL.dden.classifyPnos, { pnos }, {
                headers: { 'Content-Type': 'application/json' }
              });
              this.classifiedPnos.gm = (response.result.gm || []).join('\n');
              this.classifiedPnos.cx = (response.result.cx || []).join('\n');
              this.classifiedPnos.unknown = (response.result.unknown || []).join('\n');
          } catch (error) {
              const errorMessage = this.parseApiError(error);
              this.addError(this.$t('emg.listMsg.classifyFailed', { error: errorMessage }));
              this.batchAddModalVisible = false;
          } finally {
              this.batchAddLoading = false;
          }
      },

      handleEditTemplates() {
          this.templateVisible = true;
      },
      
      async handleConfirmBatchAdd() {
        if (this.classifiedPnos.gm) {
          const filledDrafts = await this.getFilledTemplates(this.classifiedPnos.gm.split('\n'), 'GM');
          if (filledDrafts.length > 0) {
              this.sendToExtension('createBatchDraftsFromContent', { drafts: filledDrafts });
          }
        }
        if (this.classifiedPnos.cx) {
          const filledDrafts = await this.getFilledTemplates(this.classifiedPnos.cx.split('\n'), 'CX');
          if (filledDrafts.length > 0) {
              this.sendToExtension('createBatchDraftsFromContent', { drafts: filledDrafts });
          }
        }
        this.batchAddModalVisible = false;
      },

      async getFilledTemplates(pnos, templateType) {
          try {
              const response = await this.$axios.post(URL.dden.getFilledTemplates, { pnos, templateType }, {
                headers: { 'Content-Type': 'application/json' }
              });
              return response.result.drafts || [];
          } catch (error) {
              const errorMessage = this.parseApiError(error);
              this.addError(this.$t('emg.listMsg.getTemplateError', { templateType, error: errorMessage }));
              return [];
          }
      },
      
      // 與 template.vue 中相同的錯誤解析工具函數
      parseApiError(error) {
        if (error.response && error.response.data && error.response.data.message) {
          return this.$t('emg.msg.apiError', { status: error.response.status, message: error.response.data.message });
        } else if (error.request) {
          return this.$t('emg.msg.networkError');
        } else {
          return error.message || this.$t('emg.msg.unknownError');
        }
      },

      showGlobalSuccess(message) {
        this.$message.success(message);
      },

      showGlobalError(message) {
        this.$message.error(message);
      },

      encrypt(text, key){
          return [...text].map((x, i) => 
          (x.codePointAt() ^ key.charCodeAt(i % key.length) % 255)
          .toString(16)
          .padStart(2,"0")
        ).join('')
      },

      decrypt(text, key){
          return String.fromCharCode(...text.match(/.{1,2}/g)
          .map((e,i) => 
            parseInt(e, 16) ^ key.charCodeAt(i % key.length) % 255)
          )
      },

      async getGCrExtnId() {  // 获取 Google Chrome 扩充功能 ID
        this.errorMessage = null;
        try {
          const response = await this.$axios.get(URL.dden.getGCrExtnId);
          return response;
        } catch (error) {
          this.errorMessage = this.parseApiError(error);
          console.error(this.errorMessage + ' |', error);
        }
      },

      async sendToExtension(action, data) {
        try {
              if (!window.chrome || !window.chrome.runtime || typeof window.chrome.runtime.sendMessage !== 'function') {
                  throw new Error(this.$t('emg.listMsg.extensionAPIError'));
              }

              const response = await this.getGCrExtnId();
              if (!response || !response.result) {
                  throw new Error(this.$t('emg.listMsg.extensionIdError'));
              }
              const extensionId = response.result;

              chrome.runtime.sendMessage(extensionId, { action, data }, (response) => {
                  if (chrome.runtime.lastError) {
                      this.addError(this.$t('emg.listMsg.extensionCommError', { message: chrome.runtime.lastError.message }));
                      return;
                  }
                  if (!response || !response.success) {
                      const errorMsg = (response && response.error) ? response.error : this.$t('emg.listMsg.unknownError');
                      this.addError(this.$t('emg.listMsg.extensionOpError', { error: errorMsg }));
                  } else {
                      console.log(this.$t('emg.listMsg.extensionOpSuccess', { action }));
                      if (action === 'createBatchDraftsFromContent' || action === 'openDraftWindowWithContent') {
                          this.showGlobalSuccess(this.$t('emg.listMsg.extensionSuccess'));
                      }
                  }
              });
          } catch (error) {
              this.addError(`${error.message} ${this.$t('emg.listMsg.extensionOnlyMessage')}`);
          }
      }
    },

    mounted() {
      // 組件掛載後立即執行初始查詢，確保在任何語言下行為都一致。
      // 我們傳遞一個空物件來獲取所有記錄。
      this.$refs.childTable.defaultGetData({});
    },

    async beforeMount() {
      let url = URL.dden.add;
      let label = getQueryString('label');
      let token = this.encrypt(getToken(label), label)
      await this.sendToExtension('setAuthorization', {url, label, token});
    },

  }
</script>

<style scoped>
.draft-actions-form {
    background-color: #f5f7fa;
    padding: 15px;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    margin-bottom: 10px;
}
.pno-textarea {
    width: 350px;
}
.validation-error {
    color: #f56c6c;
    background-color: #fef0f0;
    border: 1px solid #fde2e2;
    padding: 8px 12px;
    border-radius: 4px;
    white-space: pre-wrap;
    margin-left: 10px;
    margin-bottom: 15px;
    line-height: 1.4;
}
.action-buttons {
    vertical-align: top;
}
.error-list {
  list-style-type: none;
  padding-left: 0;
  margin: 0;
}
</style>
